<template>
  <div style="height:100%">
    <div class="main">
      <div class="header">
        <a-button @click="openConfig" type="primary">{{ $t("page_console_notification_rule_add") }}</a-button>
        <div>
          <a-button @click="searchForm">{{
            $t("page_my_document_advanced")
          }}</a-button>
        </div>
      </div>
      <div class="body">
        <ml-table
          :columns="columns"
          :dataSource="data"
          :canChangeColWidth="true"
          :scroll="{ x: 500, y: 500 }"
          rowKey="id"
          :custom-row="rowClick"

        >
          <template slot="maintenance" slot-scope="text, record">
            <a
              v-if="record.id"
              @click="openEdit(record)"
              >{{ $t("edit") }}</a
            >
            <a-popconfirm
              :title="$t('delete_tips')"
              ok-text="Yes"
              cancel-text="No"
              @confirm="delect(record)"
              @cancel="cancel"
            >
              <a v-if="record.id" style="color:red;margin-left:8px">{{ $t("delete") }}</a>
            </a-popconfirm>
          </template>
        </ml-table>
        <a-pagination
        style="float:right;margin-top:20px;margin-right:20px;"
        :total="pagination.total"
        :showTotal="total => `${totalFanyi(total)}`"
        :pageSize="pagination.pageSize"
        :current="pagination.current"
        @change="pageIndexchange"
      ></a-pagination>
      </div>
    </div>
    <a-modal
      :title="modalTitle"
      :visible="ConfigVisible"
      @cancel="handleCancel"
    >
      <div>
        <a-form-model
          ref="ruleForm"
          :model="configList"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :rules="rules"
        >
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label="$t('page_console_notification_type') + ':'"
                prop="type"
              >
                <a-select
                  show-search
                  :filter-option="filterOption"
                  v-model="configList.type"
                  :placeholder="$t('please_select') + $t('page_console_notification_type')"
                  :disabled="type === 'edit'"
                  @change="changeType"
                >
                  <a-select-option
                    v-for="(item, index) in typesList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label="$t('page_console_notification_configure') + ':'"
                prop="notifyId"
              >
                <a-select
                  show-search
                  :filter-option="filterOption"
                  v-model="configList.notifyId"
                  :placeholder="$t('please_select') + $t('page_console_notification_configure')"
                  @change="changeNotify"
                >
                  <a-select-option
                    v-for="(item, index) in notifyList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label="$t('page_console_notification_business_name') + ':'"
                prop="name"
              >
                <a-select
                  show-search
                  :filter-option="filterOption"
                  v-model="configList.name"
                  :placeholder="$t('please_select') + $t('page_console_notification_business_name')"
                  :disabled="type === 'edit'"
                  @change="changeBusiness"
                >
                  <a-select-option
                    v-for="(item, index) in dictList"
                    :key="index"
                    :value="item.dictKey"
                  >
                    {{ item.dictValue }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label="$t('page_console_notification_model') + ':'"
                prop="model"
              >
                <a-select
                  show-search
                  :filter-option="filterOption"
                  v-model="configList.model"
                  :placeholder="$t('please_select') + $t('page_console_notification_model')"
                >
                  <a-select-option
                    v-for="(item, index) in modelList"
                    :key="index"
                    :value="item.value"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div slot="footer">
        <a-button @click="handleCancel" style="margin-top:5px">{{
          $t("cancel")
        }}</a-button>
        <a-popconfirm
          :title="$t('page_console_notification_tip')"
          :ok-text="$t('confirm')"
          :cancel-text="$t('cancel')"
          @confirm="submit"
          @cancel="hide"
          :visible="visible"
        >
          <a-button
            @click="handleOk"
            style="margin-top:5px;background-color:#3a7fbc;color:#fff;border-color: #3a7fbc"
            >{{ $t("ok") }}</a-button
          >
        </a-popconfirm>
      </div>
      <!-- <a-modal title="确认" :visible="visible" @ok="submit" @cancel="hide">
        <div>已有一种通知方式存在，确认会覆盖</div>
      </a-modal> -->
    </a-modal>
    <dragModal
      :title="$t('page_my_document_advanced')"
      :subTitle="`(${$t('page_console_notification_method')})`"
      :visible="searchVisible"
      top="140px"
      @ok="searchOk"
      @close="searchCancel"
    >
      <a-form-model
        ref="ruleForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item :label="$t('page_console_notification_type') + ':'">
          <a-select
            show-search
            :filter-option="filterOption"
            v-model="searchList.type"
            :placeholder="$t('please_select') + $t('page_console_notification_type')"
            :disabled="type === 'edit'"
            @change="changeType"
          >
            <a-select-option
              v-for="(item, index) in typesList"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select></a-form-model-item
        ><a-form-model-item
          :label="$t('page_console_notification_configure') + ':'"
        >
          <a-select
          show-search
            :filter-option="filterOption"
            v-model="searchList.notifyId"
            :placeholder="$t('please_select') + $t('page_console_notification_configure')"
            @change="changeNotify"
          >
            <a-select-option
              v-for="(item, index) in notifyList"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select></a-form-model-item
        ><a-form-model-item
          :label="$t('page_console_notification_business_name') + ':'"
        >
          <a-select
          show-search
            :filter-option="filterOption"
            v-model="searchList.name"
            :placeholder="$t('please_select') + $t('page_console_notification_business_name')"
            @change="changeBusiness"
          >
            <a-select-option
              v-for="(item, index) in dictList"
              :key="index"
              :value="item.dictKey"
            >
              {{ item.dictValue }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('page_console_notification_model') + ':'">
          <a-select
          show-search
            :filter-option="filterOption"
            v-model="searchList.model"
            :placeholder="$t('please_select') + $t('page_console_notification_model')"
          >
            <a-select-option
              v-for="(item, index) in modelList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <div style="text-align:center;padding-bottom:10px;" slot="footer">
        <a-button @click="searchOk" type="primary">{{$t('common_search')}}</a-button>
        <a-button @click="onSearchReset" style="margin-left: 10px;" type="default">{{
          $t('common_reset')
        }}</a-button>
      </div>
    </dragModal>
  </div>
</template>

<script>
import {
  BusinessNotifyServiceProxy,
  NotifierConfigServiceProxy,
  NotifierTemplateServiceProxy,
} from "@/service-proxies/app-v2/notify.service-proxies";
import { DictServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { getLocalStorage } from '@/utils/storage';
const businessNotifyServiceProxy = new BusinessNotifyServiceProxy();
const notifierConfigServiceProxy = new NotifierConfigServiceProxy();
const notifierTemplateServiceProxy = new NotifierTemplateServiceProxy();
const dictServiceProxy = new DictServiceProxy();

export default {
  data() {
    return {
      ConfigVisible: false,
      visible: false,
      searchVisible: false,
      keyWords: "",
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      data: [],
      selectedRowKeys: [],
      typesList: [],
      notifyList: [],
      modelList: [],
      dictList: [],
      tenantId: "",
      id: "",
      type: "add",
      pagination: {
        total: 0,
        pageSize: 30,
        current: 1,
      },
      configList: {
        type: undefined,
        notifyId: undefined,
        name: undefined,
        model: undefined
      },
      searchList: {
        type: undefined,
        notifyId: undefined,
        name: undefined,
        model: undefined
      }
    };
  },
  created() {
    this.list();
  },
  watch: {
    ConfigVisible: {
      handler(val) {
        if (val) {
          this.getAllNotifyTypes();
          this.dictionary();
        }
      },
    },
    "configList.type": {
      handler(val) {
        if (val) {
          this.getAvailableNotifyConfig(val);
        }
      },
    },
    "configList.name": {
      handler(val) {
        if (val) {
          this.getCanUseNotifyConfig(val, this.configList.notifyId);
        }
      },
    },
    searchVisible: {
      handler(val) {
        if (!val) {
          // this.searchList.notifyId = "";
          // this.searchList.type = "";
          // this.searchList.name = "";
          // this.searchList.model = "";
        } else {
          this.getAllNotifyTypes();
          this.dictionary();
        }
      },
    },
  },
  computed: {
    rules() {
      return {
        type: [{ required: true, message: this.$t('page_material_warehousing_p_select'), trigger: "blur" }],
        notifyId: [{ required: true, message: this.$t('page_material_warehousing_p_select'), trigger: "blur" }],
        name: [{ required: true, message: this.$t('page_material_warehousing_p_select'), trigger: "blur" }],
        model: [{ required: true, message: this.$t('page_material_warehousing_p_select'), trigger: "blur" }],
      }
    },
    columns() {
      return [
        {
          title: this.$t("actions"),
          dataIndex: "maintenance",
          ellipsis: true,
          width: 40,
          scopedSlots: { customRender: "maintenance" },
        },
        {
          title: this.$t("page_console_notification_business_name"),
          dataIndex: "businessName",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_console_notification_type"),
          dataIndex: "notifyType",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_console_notification_configure"),
          dataIndex: "notifyName",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_console_notification_model"),
          dataIndex: "notifyTemplateName",
          ellipsis: true,
          width: 80,
        },
      ];
    },
    modalTitle() {
      return this.type === "edit"
        ? this.$t("edit")
        : this.$t("page_workstation_maintain_config");
    },
  },
  methods: {
    getCheckboxProps(record) {
      return ({
        style: {
          display: record.id ? 'block' : 'none'
        },
        props: {
          disabled: record.id ? false: true
        }
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    pageIndexchange(currentPage) {
      this.pagination.current = currentPage;
      this.list();
    },
    totalFanyi(number) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
    async list() {
      let res = await businessNotifyServiceProxy.list(
        this.searchList.name,
        this.searchList.notifyId,
        this.searchList.model,
        this.searchList.type,
        this.pagination.current,
        this.pagination.pageSize
      );
      this.pagination.total = res.records.length;
      // this.data = res.records;

      let dataLength = res.records.length;
      let copy = JSON.parse(JSON.stringify(res.records));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {
            // id: 'none'
          }
          copy.push(obj)
        }
      }
      this.data = JSON.parse(JSON.stringify(copy));


      // console.log(88888, this.data);
    },
    async getAllNotifyTypes() {
      let res = await notifierConfigServiceProxy.getAllNotifyTypes();
      this.typesList = res;
      console.log(res, 55);
    },
    async getAvailableNotifyConfig(val) {
      let res = await notifierConfigServiceProxy.getAvailableNotifyConfig(val);
      this.notifyList = res;
      console.log(9999, res);
    },
    async getCanUseNotifyConfig(key, id) {
      let res = await notifierTemplateServiceProxy.getCanUseNotifyConfig(
        key,
        id
      );
      this.modelList = res;
      console.log(8888, res);
    },
    async remove(id) {
      await businessNotifyServiceProxy.remove(id).then((res) => {
        this.$message.success(this.$t('page_ops_customer_delete_success'));
        this.list();
      });
    },
    async dictionary() {
      let res = await dictServiceProxy.dictionary("notify-biz-key");
      this.dictList = res.data;
    },
    submit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const dictItem = this.dictList.find(
            (res, index) => this.configList.name === res.dictKey
          );
          const notifyItem = this.notifyList.find(
            (res, index) => this.configList.notifyId === res.id
          );
          const modelItem = this.modelList.find(
            (res, index) => this.configList.model === res.value
          );
          if (this.type === "add") {
            var param = {
              businessKey: this.configList.name,
              businessName: dictItem.dictValue,
              isDefault: 0,
              notifyId: this.configList.notifyId,
              notifyName: notifyItem.name,
              notifyTemplateId: this.configList.model,
              notifyTemplateName: modelItem.name,
              notifyType: this.configList.type,
              tenantId: getLocalStorage("USER_INFO").tenant_id,
            };
          } else {
            var param = {
              businessKey: this.configList.name,
              businessName: dictItem.dictValue,
              id: this.id,
              isDefault: 0,
              notifyId: this.configList.notifyId,
              notifyName: notifyItem.name,
              notifyTemplateId: this.configList.model,
              notifyTemplateName: modelItem.name,
              notifyType: this.configList.type,
              tenantId: this.tenantId,
            };
          }
          await businessNotifyServiceProxy.submit(param).then((res) => {
            this.list();
            this.$message.success(this.$t('page_resource_pool_success'));
            this.handleCancel();
            this.visible = false;
          });
        }
      });
    },
    async checkIs() {
      await businessNotifyServiceProxy
        .checkIsExistsCustomBusinessNotify(
          this.configList.name,
          this.configList.type
        )
        .then((res) => {
          this.visible = res;
          console.log(5555, this.visible);
          if (res === false) {
            this.submit();
          }
        });
    },
    openConfig() {
      this.type = "add";
      this.ConfigVisible = true;
    },
    handleOk() {
      this.checkIs();
      // this.submit();
    },
    handleCancel() {
      this.$refs.ruleForm.resetFields();
      this.configList.type = undefined
      this.configList.notifyId = undefined
      this.configList.model = undefined
      this.configList.name = undefined
      console.log(555, this.configList);
      this.ConfigVisible = false;
    },
    searchForm() {
      this.searchVisible = !this.searchVisible;
    },
    openEdit(val) {
      this.id = val.id;
      this.tenantId = val.tenantId;
      const dataItem = this.data.find((res, index) => val.id === res.id);
      this.configList.type = dataItem.notifyType;
      this.configList.notifyId = dataItem.notifyId;
      this.configList.model = dataItem.notifyTemplateId;
      this.configList.name = dataItem.businessKey;
      this.type = "edit";
      this.ConfigVisible = true;
      console.log(888);
    },
    changeNotify(val) {
      if (this.configList.name || this.searchList.name) {
        this.getCanUseNotifyConfig(
          this.configList.name || this.searchList.name,
          val
        );
      }
    },
    delect(val) {
      this.remove(val.id);
    },
    onSelect(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    changeType(val) {
      this.configList.notifyId = undefined
      this.configList.model = undefined
      this.searchList.notifyId = undefined
      this.searchList.model = undefined
      this.getAvailableNotifyConfig(val);
      console.log(888);
    },
    changeBusiness(val) {
      if (this.configList.notifyId || this.searchList.notifyId) {
        this.getCanUseNotifyConfig(
          val,
          this.configList.notifyId || this.searchList.notifyId
        );
      }
    },
    cancel(e) {
      console.log(e);
    },
    hide() {
      this.visible = false;
      console.log(9999);
    },
    searchOk() {
      this.list();
      // this.searchVisible = false;
    },
    onSearchReset(){
      this.searchList.notifyId = undefined
      this.searchList.type = undefined
      this.searchList.name = undefined
      this.searchList.model = undefined
    },
    searchCancel() {
      this.searchVisible = false;
    },
    rowClick(record) {
      return {
        on: {
          click: (event) => {
            this.selectedRowKeys = [];
            this.selectedRowKeys.push(record.id);
          },
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 100%;
  width: 100%;
  background-color: #fff;
  .header {
    display: flex;
    justify-content: space-between;
    padding: 18px 0px;
  }
}
/deep/ .ant-row .ant-form-item {
  display: flex;
}
/deep/ .ant-modal-content {
  width: 1000px;
  margin-left: -100px;
}

/deep/ .ant-table-selection-column {
  width: 44px!important;
}
</style>
